import { apiClient } from '../../axios';
import { GetFavoritesParams, GetFavoritesResponse, GetMarketBoostResponse } from './types';

export const getFavoritesApi = (params?: GetFavoritesParams) =>
  apiClient.get<GetFavoritesResponse>('/v1/market/favorites', { params });

export const putFavoriteApi = (symbol: string, data: { favorite: boolean }) =>
  apiClient.put(`/v1/market/favorite/${symbol}`, data);

export const getMarketBoostApi = () => apiClient.get<GetMarketBoostResponse>('/v1/market/boost');
